import {Injectable} from '@angular/core';
import * as Sentry from '@sentry/angular';
import {environment} from "@env/environment";

@Injectable({
  providedIn: 'root'
})
export class SentryErrorService {

  constructor() {
  }

  static captureException(exception: any) {
    console.error('SentryErrorService.captureException', exception);
    return new Promise<void>(async resolve => {
      if (environment.sentry_dsn) {
        Sentry.captureException(exception);
      } else {
        console.error('SentryErrorService not captured');
      }

      resolve();
    })
  }
}
